import React from 'react'
import clsx from 'clsx'

import { Button } from '@wartek-id/button-v1'

type TFooterActionProps = {
  hasBackButton?: boolean
  isBackDisabled?: boolean
  isNextDisabled?: boolean
  nextLabel?: string | React.ReactNode
  onBack?: () => void
  onNext?: () => void
}
export const FooterActionV2: React.FC<TFooterActionProps> = ({
  hasBackButton = false,
  isBackDisabled = false,
  isNextDisabled = false,
  nextLabel = 'Lanjut',
  onBack = () => {},
  onNext = () => {},
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-10 flex justify-center w-full p-4 bg-white border-subdued shadow-[inset_0px_5px_3px_-3px_rgba(0,0,0,0.08)]">
      <div
        className={clsx(
          'flex w-full max-w-7xl ',
          hasBackButton ? 'justify-around space-x-4' : 'justify-center'
        )}
      >
        {hasBackButton && (
          <Button
            fullWidth
            data-testid="footer-action-back"
            color={isBackDisabled ? 'black' : 'white'}
            variant={isBackDisabled ? 'ghost' : 'solid'}
            size="md"
            className="!px-6"
            disabled={isBackDisabled}
            onClick={onBack}
          >
            Sebelumnya
          </Button>
        )}
        <Button
          fullWidth
          data-testid="footer-action-next"
          color={isNextDisabled ? 'black' : 'blue'}
          variant={isNextDisabled ? 'ghost' : 'solid'}
          size="md"
          className="!px-6"
          disabled={isNextDisabled}
          onClick={onNext}
        >
          {nextLabel}
        </Button>
      </div>
    </div>
  )
}
